// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCXkVx3SudvBBAnKIW_XfCR7QlDujeZdzE",
  authDomain: "wallof-business.firebaseapp.com",
  projectId: "wallof-business",
  storageBucket: "wallof-business.firebasestorage.app",
  messagingSenderId: "799453095629",
  appId: "1:799453095629:web:f19020c502fd28aecd2b84",
  measurementId: "G-B70RX094QW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const cFunctions = getFunctions(app);
const firestore = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, cFunctions, firestore, analytics, auth, storage };
